module.exports = __webpack_public_path__ + "static/media/lendas colecionaveis.c6a4c841.png";